// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"599":"197392f8","851":"197392f8"}[chunkId] + ".chunk.css";
};